import React from 'react';
import Cursor from '../../../../../../../../../../../css/ppt-editor-cursor-global.less';
import * as commonFun from '../../../../common';
import ConnectorStartEndPoint, { ConnectorStartEndPointProps } from './start-end-point';
import { mobxSet } from '@src/slide/infrastructure/module/independent/assert/get-set';
import {
    ADSORP_ANGLE,
    ADSORP_RANGE } from '../../../../../../../../../../../slide/infrastructure/module/independent/graphic/rotate';
import { pointInRect } from '@src/slide/infrastructure/module/independent/graphic';

const CONTAINER_LENGTH = 16;
const BORDER_LENGTH = 14;
const INNER_LENGTH = 10;

interface ConnectorStartEndPointMobileProps extends ConnectorStartEndPointProps {
    isConnecting?: boolean;
}

export default class ConnectorStartEndPointMobile extends ConnectorStartEndPoint<ConnectorStartEndPointMobileProps> {
    private toBeConnectingElements;
    private isMovingConnector;
    public render() {
        const frame = this.props.element.getFrame?.().getFrameInfo(true);
        this.context.editingStateManager.readyToConnect = true;
        const startAndEndPoints = [{
            x: 0,
            y: 0,
        }, {
            x: frame.width,
            y: frame.height,
        },
        ];
        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    transform: commonFun.transformOfFlip(frame),
                    pointerEvents: 'none',
                }}
            >
                {
                    startAndEndPoints.map(this.renderStartAndEndPoint)
                }
            </div>
        );
    }

    public componentWillUnmount() {
        this.context.editingStateManager.readyToConnect = false;
    }

    protected renderStartAndEndPoint = (point, index) => {
        const { scale } = this.props;
        return (
            <div
                key={index}
                style={{
                    left: (point.x * scale) - 25,
                    top: (point.y * scale) - 25,
                    position: 'absolute',
                    pointerEvents: 'auto',
                    height: 48,
                    width: 48,
                    display: this.props.isConnecting ? 'none' : 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                className={Cursor['nwse-resize']}
                onMouseDown={this.handleStartEndPointMouseDown.bind(this, index)}
                onTouchStart={this.handleStartEndPointMouseDown.bind(this, index)}
            >

                <div
                    style={{
                        width: CONTAINER_LENGTH,
                        height: CONTAINER_LENGTH,
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div style={{
                        width: BORDER_LENGTH,
                        height: BORDER_LENGTH,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                    }}>
                        <div
                            style={{
                                width: INNER_LENGTH,
                                height: INNER_LENGTH,
                                borderRadius: '50%',
                                backgroundColor: '#1E6FFF',
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    };

    protected handleStartEndPointMouseDown = (index, e) => {
        e.stopPropagation();
        e.preventDefault();
        this.startPos = this.getEventCoordinates(e);
        this.changeStartEndIndex = index;
        this.context.editingStateManager.isConnecting = true;
        this.toBeConnectingElements = document.getElementsByClassName('connecting-element-cover');
        document.body.addEventListener('mousemove', this.handleStartEndPointMouseMove);
        document.body.addEventListener('mouseup', this.handleStartEndPointChangeEnd);
        document.body.addEventListener('touchmove', this.handleStartEndPointMouseMove, { passive: false });
        document.body.addEventListener('touchend', this.handleStartEndPointChangeEnd);
    };

    protected handleStartEndPointMouseMove = (e) => {
        if (!e.isTrusted) {
            return;
        }
        e.preventDefault();
        if (!this.isMovingConnector) {
            this.context.editingStateManager.connectingInfo = {
                model: this.props.element,
                endIndex: this.changeStartEndIndex,
            };
            this.isMovingConnector = true;
            if (this.changeStartEndIndex === 0) {
                // 如果连接的图形也没有被选中，需要被置空
                const startModel = this.props.element.startUIModel;
                if (startModel) {
                    this.props.element.props.style.connectorInfo.start = null;
                    startModel.removeRelatedUIModelRefs(this.props.element);
                }
            } else if (this.changeStartEndIndex === 1) {
                // 如果连接的图形也没有被选中，需要被置空
                const endModel = this.props.element.endUIModel;
                if (endModel) {
                    this.props.element.props.style.connectorInfo.end = null;
                    endModel.removeRelatedUIModelRefs(this.props.element);
                }
            }
        }
        const currentEventPos = this.getEventCoordinates(e);
        // 计算出相对与屏幕的偏移
        const realOffset = {
            x: (currentEventPos.x - this.startPos.x) / this.props.scale,
            y: (currentEventPos.y - this.startPos.y) / this.props.scale,
        };
        let offset;
        offset = this.getAdsorpOffset(ADSORP_RANGE, ADSORP_ANGLE, {
            endIndex: this.changeStartEndIndex,
            offset: realOffset,
        });
        if (e.shiftKey) {
            offset = this.sameRatioOffset({
                endIndex: this.changeStartEndIndex,
                offset,
            });
        }
        const updateSytle = this.props.element.connectorCaculater?.getUpdateStyle(null, {
            endIndex: this.changeStartEndIndex,
            offset,
        });
        this.props.element.updateModelStyle(updateSytle);
        this.dispatchMoveEvent(e);
    };

    protected handleStartEndPointChangeEnd = (e) => {
        e.stopPropagation();
        e.preventDefault();
        document.body.removeEventListener('mousemove', this.handleStartEndPointMouseMove);
        document.body.removeEventListener('mouseup', this.handleStartEndPointChangeEnd);
        document.body.removeEventListener('touchmove', this.handleStartEndPointMouseMove);
        document.body.removeEventListener('touchend', this.handleStartEndPointChangeEnd);
        const styleModel = this.props.element.props.style;
        const toRemove = this.props.element.toRemoveConnectorInfoProps();
        const updateProps = {
            style: {
                ...this.props.element.operationFrame,
                bgLine: styleModel.bgLine,
                controlValues: styleModel.controlValues,
                connectorInfo: this.props.element.props.style.connectorInfo,
            },
        };
        if (toRemove) {
            this.props.element.updateAndRemoveProps(updateProps, toRemove);
        } else {
            this.props.element.updateProps(updateProps);
        }
        mobxSet(this.props.element, 'operationFrame', null);
        if (this.context.editingStateManager.isConnecting) {
            this.context.editingStateManager.isConnecting = false;
            this.context.editingStateManager.connectingInfo = null;
        }
        this.dispatchMoveEndEvent(e);
        this.toBeConnectingElements = [];
        if (this.props.element.getConnectorInfo()) {
            this.props.element.buildRelation();
        }
        this.isMovingConnector = false;
    };

    protected dispatchMoveEndEvent(e) {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < this.toBeConnectingElements.length; i++) {
            const element = this.toBeConnectingElements[i];
            if (!element) {
                break;
            }
            const newEvent = new MouseEvent('mouseout', e);
            element.dispatchEvent(newEvent);
        }
    }


    protected dispatchMoveEvent(e) {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < this.toBeConnectingElements.length; i++) {
            const element = this.toBeConnectingElements[i];
            if (!element) {
                break;
            }
            const { top, left, width, height } = element.getBoundingClientRect();
            const [{ clientX, clientY }] = e.changedTouches;
            if (pointInRect({ x: clientX, y: clientY }, { top, left, width, height })) {
                const newEvent = new TouchEvent('touchmove', e);
                element.dispatchEvent(newEvent);
            } else {
                const newEvent = new MouseEvent('mouseout', e);
                element.dispatchEvent(newEvent);
            }
        }
    }
}
